<mat-card class="card">
    <p i18n class="mat-card-header">Make my tree</p>
    <mat-card-content>
        <div class="select-person-container">
            
            <mat-card-content class="select-person-info">
                <div class="info-text-container">
                    <h2 i18n class="label">Info:</h2>
                    <p i18n class="info-text">
                        Select a starting person, size (up to 10 generations), and format (portrait or landscape) for
                        your family tree. Create unlimited designs but save them for easy access. Find saved family
                        trees under "Design" or create a new tree under "Create my tree" in the menu.
                    </p>
                </div>
            </mat-card-content>
            <div class="selection-container">
                <div class="select-person">
                    <h2 i18n class="label">Select start person</h2>
                    <mat-select required [formControl]="selectStartPerson" class="select-box">
                        <input (keyup)="onKeySingle($event.target.value)" class="searchInput" placeholder="Search..."
                            [style]="'border: none'">
                        <mat-option i18n *ngFor="let single of individuals; let i = index" [(value)]="single['id']">
                            {{single['firstName']}}&nbsp;{{single['lastName']}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="select-person">
                    <h2 i18n class="label">Select paper size</h2>
                    <mat-select [(value)]="papertype" class="select-box">
                        <mat-option i18n value="A0"> A0 (841 x 1188 mm MAX 10 GENERATIONS) </mat-option>
                        <mat-option i18n value="A1"> A1 (594 x 841 mm MAX 9 GENERATIONS) </mat-option>
                        <mat-option i18n value="A2"> A2 (420 x 594 mm MAX 7 GENERATIONS) </mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
        <div class="select-design-container">
            <div class="select-design">
                <h2 i18n>Vertical designs:</h2>
                <div class="designs">
                    <div *ngFor="let design of designs" (click)="selectedDesign = design">
                        <div class="design" *ngIf="design.data.direction <= 2">
                            <img src='{{design.data.thumbnail? design.data.thumbnail : "assets/image/ancytree.logo.png"}}'
                                [ngClass]="{'selected': selectedDesign === design}" class="vertical">
                        </div>
                    </div>
                </div>
            </div>
            <div class="select-design">
                <h2 i18n>Horizontal designs:</h2>
                <div class="designs">
                    <div *ngFor="let design of designs" (click)="selectedDesign = design">
                        <div class="design" *ngIf="design.data.direction >= 3">
                            <img src='{{design.data.thumbnail? design.data.thumbnail : "assets/image/ancytree.logo.png"}}'
                                [ngClass]="{'selected': selectedDesign === design, 'horizontal' : design.data.direction >= 3 && design.data.thumbnail, 'vertical' : !design.data.thumbnail}">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button (click)="generateTree()" [disabled]="validate()" i18n>Build Tree</button>
    </mat-card-content>
</mat-card>